function PatientMeedyVO(id, firstName, lastName, identifierType, identifier, gender, birthday, address, mainPhone, additionalPhone,
                   fax, email, notes, insurer) {

    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.identifierType = identifierType;
    this.identifier = identifier;
    this.gender = gender;
    this.birthday = birthday;
    this.address = address;
    this.mainPhone = mainPhone;
    this.additionalPhone = additionalPhone;
    this.fax = fax;
    this.email = email;
    this.notes = notes;
		this.insurer = insurer;

    var _typeContext = {
        birthday : Date,
				insurer : InsurerMeedyVO,
        address : AddressMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
